export const mustBeWebsite = (v: string) => {
    return v.includes('http')
}